const PATH = "/api/v1/wallet";

const ENDPOINTS = {};

export type WalletEndpoints = keyof typeof ENDPOINTS;
export const WalletCollection = { PATH, ENDPOINTS };
